import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getRole, isLoggedIn } from "../../auth";
import { usePermission } from "./PermissionContext";

export function RoleRoute({ children, allowRoles = [], requiredPermission = "" }) {
  const location = useLocation();
  const { can, initialized } = usePermission();

  if (!isLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const role = (getRole() || "").toLowerCase();
  const allowed = allowRoles.map((x) => (x || "").toLowerCase());
  if (allowed.length > 0 && !allowed.includes(role)) {
    return <Navigate to="/gps-monitor" replace />;
  }

  if (requiredPermission) {
    if (!initialized) {
      return null;
    }
    if (!can(requiredPermission)) {
      return <Navigate to="/gps-monitor" replace />;
    }
  }

  return children;
}

